<script>
import {nextTick} from 'vue';

export default {
    props: {
        locale: String
    },
    data() {
        return {
            container: null,
            isLoaded: false,
            isSubmitted: false,
            error: {message: null, status: false},
            isAccepted: true,
            province: [],
            config: {
                email: '',
                selectedProvince: {
                    "kanton": "Bern",
                    "nothelfer": 130,
                    "sehtest": 20,
                    "lernfahrausweis": 50,
                    "bestaetigungEinwohnerkontrolle": 20,
                    "theorieLernen": 20,
                    "theoriepruefung": 30,
                    "lernfahrausweisAusstellen": 20,
                    "fahrstunden": 90,
                    "administration": 100,
                    "vku": 200,
                    "praktischePruefung": 132,
                    "fuehrerausweisAufProbe": 45,
                    "wabKurs": 450,
                    "aenderungFuererausweisAufProbe": 30,
                    "pauschale": 0
                },
                locale: 'de',
                isMember: false,
                hours: 1,
                pricePerHour: 90
            }
        }
    },
    beforeMount() {
    },
    mounted() {
        this.container = document.querySelector('.js-vue-price-configurator');
        this.container.classList.remove('is-element-loading');
        this.container.classList.remove('has-hidden-children');
        this.config.locale = this.locale;

        this.load();
    },
    watch: {
        'config.selectedProvince': function (newValue) {
            this.config.pricePerHour = this.config.selectedProvince.fahrstunden;
        },
        'config.pricePerHour': function (newValue) {
            if (newValue < 0) {
                this.config.pricePerHour = 0;
            }
        }
    },
    methods: {
        load: function () {
            let _this = this;

            fetch("/ajax/price-calculator/getProvince", {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(_this.form)
            })
                .then(function (response) {
                    return response.json();
                })
                .then(function (response) {
                    if (response.success) {
                        _this.province = response.data;
                        _this.config.selectedProvince = _this.province[0];
                        _this.isLoaded = true;
                    }
                })
                .catch(function (error) {
                    //...
                });

        },
        send: function () {
            const _this = this;
            let requestData = JSON.parse(JSON.stringify(_this.config));
            requestData['total'] = _this.total;
            requestData['isOptin'] = _this.isAccepted ? 1 : 0;
            requestData['language'] = this.convertLocale(this.locale);

            if (this.config.isMember) {
                requestData['selectedProvince']['theorieLernen'] = 0; // Preis entfällt für Mitglieder
                requestData['selectedProvince']['wabKurs'] -= 100; // Rabatt WAB-Kurs
            }
            if (this.config.email !== '') {
                fetch("/ajax/price-calculator/send", {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(requestData)
                })
                    .then(function (response) {
                        return response.json();
                    })
                    .then(function (response) {
                        if (response.success) {
                            _this.isSubmitted = true;
                            _this.error.status = false;
                        } else {
                          _this.error.status = true;
                          _this.error.message = response.error;
                        }
                    })
                    .catch(function (error) {
                        console.log(error)
                    });
            }
        },
        convertLocale: function (locale) {
          if (locale === 'de') return 'D'
          if (locale === 'fr') return 'F'
          if (locale === 'it') return 'I'
          else return locale
        },
    },
    computed: {
        nonMemberTotalRaw() {
            let total = this.config.hours * this.config.pricePerHour;
            if (this.config.selectedProvince) {
                total += this.config.selectedProvince.nothelfer;
                total += this.config.selectedProvince.sehtest;
                total += this.config.selectedProvince.lernfahrausweis;
                total += this.config.selectedProvince.bestaetigungEinwohnerkontrolle;
                total += this.config.selectedProvince.theorieLernen;
                total += this.config.selectedProvince.theoriepruefung;
                total += this.config.selectedProvince.lernfahrausweisAusstellen;
                total += this.config.selectedProvince.administration;
                total += this.config.selectedProvince.vku;
                total += this.config.selectedProvince.praktischePruefung;
                total += this.config.selectedProvince.fuehrerausweisAufProbe;
                total += this.config.selectedProvince.wabKurs;
                total += this.config.selectedProvince.aenderungFuererausweisAufProbe;
                total += this.config.selectedProvince.pauschale;
            }
            return total;
        },
        memberDiscountRaw() {
            if (!this.config.selectedProvince) return 0;
            // TheorieLernen is free for members + WAB-Kurs is discounted for members
            return this.config.selectedProvince.theorieLernen + 100;
        },
        total() {
            const value = this.config.isMember ? this.memberTotalRaw : (this.nonMemberTotalRaw - this.memberDiscountRaw);
            return Intl.NumberFormat('en-CH', { style: 'currency', currency: 'CHF', useGrouping: false }).format(value);
        },
        memberTotal() {
            return Intl.NumberFormat('en-CH', { style: 'currency', currency: 'CHF', useGrouping: false }).format(this.nonMemberTotalRaw - this.memberDiscountRaw);
        },
        nonMemberTotal() {
            return Intl.NumberFormat('en-CH', { style: 'currency', currency: 'CHF', useGrouping: false }).format(this.nonMemberTotalRaw);
        },
        discount() {
            return Intl.NumberFormat('en-CH', { style: 'currency', currency: 'CHF', useGrouping: false }).format(this.memberDiscountRaw);
        }
    }
};
</script>
